import React from "react";
import { Box } from "@material-ui/core";
import { FaCheck, FaTimes, FaClock } from "react-icons/fa";
import { useStyles } from "./NotificationStyles";

export interface NotificationProps {
  type?: "success" | "error" | "warning";
  message?: string;
  show: boolean;
}

const Notification: React.FC<NotificationProps> = ({ type = "success", message, show }) => {
  const classes = useStyles();

  if (!show) {
    return null;
  }

  const icon =
    type === "success" ? (
      <FaCheck className={classes.icon} />
    ) : type === "error" ? (
      <FaTimes className={classes.icon} />
    ) : (
      <FaClock className={classes.icon} />
    );

  return (
    <Box className={`${classes.notification} ${classes[type]}`}>
      {icon}
      <span className={classes.message}>{message}</span>
    </Box>
  );
};

export default Notification;
